import { render } from "./HealthHeartRateChart.vue?vue&type=template&id=1a0ab064"
import script from "./HealthHeartRateChart.vue?vue&type=script&lang=js"
export * from "./HealthHeartRateChart.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__